module.exports = __webpack_public_path__ + "static/media/righttg.e1f25110.png";